import type { ReactNode } from 'react';

import type { IconButtonsOption } from '#/components/IconButtons/IconButtonsOption';
import { IconCheckboxButtons } from '#/components/IconButtons/IconCheckboxButtons';

import { Field } from './Field/Field';

type Props<TValue extends string> = {
  name: string;
  description?: ReactNode;
  label?: ReactNode;
  options: IconButtonsOption<TValue>[];
  transformOnChange?: (values: TValue[]) => TValue[];
};

export function IconCheckboxButtonsField<T extends string>({
  name,
  description,
  label,
  options,
  transformOnChange,
}: Props<T>) {
  return (
    <Field
      name={name}
      label={label}
      description={description}
      renderInput={({ value, id, qaId, updateValue }) => {
        const safeValue = value ?? [];
        const saveValueArray = Array.isArray(safeValue)
          ? safeValue
          : [safeValue];

        return (
          <IconCheckboxButtons
            id={id}
            name={name}
            options={options}
            values={saveValueArray}
            onChange={(newValue) => {
              const transformedValue = transformOnChange
                ? transformOnChange(newValue)
                : newValue;

              updateValue(transformedValue);
            }}
            qaId={qaId}
          />
        );
      }}
    />
  );
}
